import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_INVOICE_DOWNLOAD_RECEIPT_PDF_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type { GetInvoiceReceiptPayload, GetInvoiceReceiptResult } from '../types/getReceipt.types';

export const INVOICE_RECEIPT = 'InvoiceReceipt';
export const getInvoiceReceipt = (builder: BuilderType) =>
  builder.query<GetInvoiceReceiptResult, GetInvoiceReceiptPayload>({
    providesTags: [INVOICE_RECEIPT],
    query: (params) => ({
      data: params,
      method: 'POST',
      url: GET_INVOICE_DOWNLOAD_RECEIPT_PDF_URL,
    }),

    transformResponse: (response: GenericApiResponse<GetInvoiceReceiptResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }
      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
